import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbSet;
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbIterable } from "abweb/collection/AbIterable";
export class AbSet {
  constructor(items) {
    _defineProperty(this, "_set", void 0);
    _defineProperty(this, "add", value => {
      this._set.add(value);
      return this;
    });
    _defineProperty(this, "clear", () => {
      this._set.clear();
    });
    _defineProperty(this, "delete", value => {
      return this._set.delete(value);
    });
    _defineProperty(this, "forEach", (callbackfn, thisArg) => {
      this._set.forEach((v, v2) => callbackfn(v, v2, this), thisArg);
    });
    _defineProperty(this, "has", value => {
      return this._set.has(value);
    });
    _defineProperty(this, "entries", () => {
      return this._set.entries();
    });
    _defineProperty(this, "keys", () => {
      return this._set.keys();
    });
    _defineProperty(this, "values", () => {
      return this._set.values();
    });
    _defineProperty(this, Symbol.iterator, () => {
      return this._set[Symbol.iterator]();
    });
    _defineProperty(this, "union", other => {
      return AbSet.from(this._set.union(other));
    });
    _defineProperty(this, "intersection", other => {
      return AbSet.from(this._set.intersection(other));
    });
    _defineProperty(this, "difference", other => {
      return AbSet.from(this._set.difference(other));
    });
    _defineProperty(this, "symmetricDifference", other => {
      return AbSet.from(this._set.symmetricDifference(other));
    });
    _defineProperty(this, "isSubsetOf", other => {
      return this._set.isSubsetOf(other);
    });
    _defineProperty(this, "isSupersetOf", other => {
      return this._set.isSupersetOf(other);
    });
    _defineProperty(this, "isDisjointFrom", other => {
      return this._set.isDisjointFrom(other);
    });
    _defineProperty(this, "map", mapFunction => {
      return AbSet.from(AbIterable.from(this.values()).map(mapFunction));
    });
    _defineProperty(this, "flatMap", mapFunction => {
      return AbSet.from(AbIterable.from(this.values()).flatMap(mapFunction));
    });
    _defineProperty(this, "filter", filterFunction => {
      return AbSet.from(AbIterable.from(this.values()).filter(filterFunction));
    });
    _defineProperty(this, "filterType", filterFunction => {
      return AbSet.from(AbIterable.from(this.values()).filterType(filterFunction));
    });
    _defineProperty(this, "every", predicate => {
      return AbIterable.every(this, predicate);
    });
    _defineProperty(this, "any", predicate => {
      return AbIterable.any(this, predicate);
    });
    _defineProperty(this, Symbol.toStringTag, "AbSet");
    this._set = new Set(items);
  }
  get size() {
    return this._set.size;
  }
}
_AbSet = AbSet;
_defineProperty(AbSet, "from", items => new _AbSet(items));
//# sourceMappingURL=AbSet.js.map
